import Route from '@ember/routing/route';
import type AppContactSubmitTicketController from 'walden-fast/controllers/app/contact/submit-ticket';
import { service } from '@ember/service';
import type UserService from 'walden-fast/services/user';

export default class AppContactContactRoute extends Route {
  @service('user') declare userService: UserService;

  async model() {
    const user = await this.userService.getUser();
    return {
      user,
    };
  }

  resetController(controller: AppContactSubmitTicketController) {
    controller.reset();
  }
}
